import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";

const Track15BRed = ({ state, workState, onLabelClick }) => (
	<g id="Track15BRed" transform="translate(2224.000000, 963.000000)" className="track">
		<line x1="18" y1="61.0546875" x2="18" y2="0.336288693" id="line"
					stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
					strokeWidth={tracksWidth}
					strokeLinecap="round"/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track15BRed')}
			coords="0.000000, 10.054688"
			text="15B"
			textCoordsX="7.52148438"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>
);

Track15BRed.propTypes = trackPropTypes;

export default Track15BRed;
